import {openResourceModal} from '../../core/modalCommand';
import {
	AP_MAC_ACL_CREATE_MODAL_EVENT,
	AP_MAC_ACL_EDIT_MODAL_EVENT,
	AP_MAC_ACL_DELETE_MODAL_EVENT,
} from './events';

/**
 * Open Add Access Point MAC ACL.
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openApMacAclCreateModal(command, envelope) {
	return openResourceModal(AP_MAC_ACL_CREATE_MODAL_EVENT, command, envelope);
}

/**
 * Open Edit Access Point MAC ACL.
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openApMacAclEditModal(command, envelope) {
	return openResourceModal(AP_MAC_ACL_EDIT_MODAL_EVENT, command, envelope);
}

/**
 * Open Delete Access Point MAC ACL.
 *
 * The confirmation, not the deletion. Nothing is removed until
 * the person presses the button inside it.
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openApMacAclDeleteModal(command, envelope) {
	return openResourceModal(AP_MAC_ACL_DELETE_MODAL_EVENT, command, envelope);
}
